import { Component, HostBinding } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Vehicle } from '../../../interfaces/vehicle';
import { Router } from '@angular/router';
import { UrlService } from '../../../services/url.service';
import { ApiService } from '../../../service/api.service';

@Component({
    selector: 'app-block-finder',
    templateUrl: './block-finder.component.html',
    styleUrls: ['./block-finder.component.scss'],
})
export class BlockFinderComponent {
    vehicleControl: FormControl = new FormControl(null);

    get vehicle(): Vehicle { return this.vehicleControl.value; }

    @HostBinding('class.block') classBlock = true;

    @HostBinding('class.block-finder') classBlockFinder = true;

    constructor(
        private router: Router,
        private url: UrlService,
        private service :ApiService
    ) {
        this.loadData();
    }


    submit(): void {
        // if (!this.vehicle) {
        //     return;
        // }

        // this.router.navigate([this.url.allProducts()], {
        //     queryParams: {
        //         filter_vehicle: this.vehicle.id,
        //     },
        // }).then();
        if(this.valid){
            this.router.navigateByUrl(`search/${this.filter.categoryId}/${this.filter.subCategoryId}/${this.filter.uniqueCourseId}`)

        }
    }
    category:any;
    subCategory:any;
    course:any;

    loadData(){
        this.service.getCategory().subscribe((res:any) => {
            this.category = res;
        })
        this.service.listSubCategory().subscribe((res:any) => {
            this.subCategory = res;
        })
        this.service.listUniqueCourse().subscribe((res:any) => {
            this.course = res;
        })
    }
    valid:boolean = false;
    filter :any;
    data(data){
        if(data.categoryId === "0"){
            this.valid = false
        }
        if(data.subCategoryId === "0"){
            this.valid = false
        }
        if(data.uniqueCourseId === "0"){
            this.valid = false
        }
        if(data.categoryId != "0" && data.subCategoryId != "0" && data.uniqueCourseId != "0"){
            this.valid = true
            this.filter = data
        }
        if(this.valid){
                let categoryData = this.category
                let subCategoryData = this.subCategory
                let courseData = this.course
                let x = categoryData.filter(data => data.id === Number(this.filter.categoryId));
                console.log(x)
                let y = subCategoryData.filter(data => data.id === Number(this.filter.subCategoryId));
                let z = courseData.filter(data => data.id === Number(this.filter.uniqueCourseId));


                this.filter.categoryId = x[0].slug
                this.filter.subCategoryId = y[0].slug
                this.filter.uniqueCourseId = z[0].slug


                console.log(this.filter)

        }
    }
}
